import { startOfMinute } from "date-fns";
import { isDesktopViewport, resolveGigView } from "domains/gigs/containers/ViewSwitcher/gigView";
import { gigsQuery } from "domains/schedule/containers/GigBoard/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

export type QueriesInput = {
  search: MarketplaceSearch & { tab?: "upcoming" | "past" };
  locationId: number | undefined;
  now: Date;
};

export const shiftsQuery = ({ search, locationId, now }: QueriesInput) => {
  const upcoming = (search.tab ?? "upcoming") === "upcoming";
  return gigsQuery({
    search,
    view: resolveGigView({ view: search.view, isDesktop: isDesktopViewport(), defaultView: "calendar" }),
    now,
    overrides: (minute) => ({
      end_time__gte: upcoming ? startOfMinute(minute) : undefined,
      ordering: "start_time, -id",
      statuses: upcoming ? ["UNAPPROVED", "POSTED", "CONFIRMED"] : ["INCOMPLETE"],
      location_id: locationId,
    }),
  });
};

export const queries = (input: QueriesInput): Array<WarmableQuery> => [shiftsQuery(input)];
